import React from "react";
import { useSessionStorage } from "react-use";
import { sendOAuthRequest, logout as userLogout } from '../services/AuthService';

const defaultValues = Object.freeze({
  isAuthenticated: false,
  principal: null,
  login: () => {},
  logout: () => {},
});

const STORAGE_KEY = "authentication";

export const AuthenticationContext = React.createContext(defaultValues);

export function AuthenticationProvider({ children }) {
  const [authenticated, setAuthentication] = useSessionStorage(
    STORAGE_KEY,
    defaultValues
  );

  const login = async () => {
    try {
      await sendOAuthRequest(); // Redirect to OIDC login page
    } catch (error) {
      console.error("Login failed", error);
    }
  };

  const logout = async () => {
    try {
      await userLogout(); // Redirect to OIDC login page
    } catch (error) {
      console.error("Logout failed", error);
    }
  };

  const authenticationValue = { ...authenticated, login, logout, setAuthentication };

  return (
    <AuthenticationContext.Provider value={authenticationValue}>
      {children}
    </AuthenticationContext.Provider>
  );
}

export function useAuthentication() {
  return React.useContext(AuthenticationContext);
}
